import VueCookies from 'vue-cookies'

// state
export const state = {
  played: parseInt(VueCookies.get('gifsPlayed')) || 0,
}

// getters
export const getters = {
  isGifsBlocked: ({ played }, getters, rootState, rootGetters) => {
    if (rootGetters['auth/token']) {
      return false
    }
    return played > 5
  },
}
// mutations
export const mutations = {
  incrementPlayedCount(state) {
    state.played = state.played + 1
    VueCookies.set('gifsPlayed', state.played, '12h')
  },
}
// actions
export const actions = {
  async incrementPlayedCount({ commit }) {
    commit('incrementPlayedCount')
  },
}
